export enum AuthTypes {
    UP = 1,
    Google = 2,
    Facebook = 3
}